import { getConfig } from "../configuration";
import { OktaAuth, OktaAuthOptions } from "@okta/okta-auth-js";

let oktaInstance: OktaAuth | null = null;

export function getOktaInstance(): OktaAuth {
  if (!oktaInstance) {
    try {
      oktaInstance = new OktaAuth({
        scopes: ["openid", "profile", "email"],
        responseType: ["token", "id_token"],
        pkce: true,
        tokenManager: {
          autoRenew: true,
          autoRemove: true,
          // Matches the MSAL cache: sessionStorage did not survive the task-pane reload, so Okta
          // users lost their tokens on every return. LogoutButton clears these on sign-out now.
          storage: "localStorage",
        },
        ...getConfig().okta,
      } as OktaAuthOptions);
    } catch (error) {
      // may happen if config is requested before it's loaded from server
    }

    // console.log("Used okta config with values:", getConfig().okta);
  }
  
  return oktaInstance;
}

export default getOktaInstance;
